import { configureStore } from '@reduxjs/toolkit';
import estimateReducer from './modules/estimateSlice';
import garageReducer from './modules/garageTimeline';
import userReducer from './modules/userDataSlice';
import loadingReducer from './modules/loaderSlice';
import vehicleInfoSlice from './modules/savedVehicleSlice';
import appointmentSlice from './modules/appointmentSlice';
import appointmentSliceV2 from './modules/appointmentBookingSlice';
import garageSlice from './modules/garageSlice';
import myAccountReducer from './modules/myAccount/reducer';

const reducers = {
    estimate: estimateReducer,
    garage: garageReducer,
    userData: userReducer,
    loading: loadingReducer,
    savedVehicleData: vehicleInfoSlice,
    appointmentData: appointmentSlice,
    bookingData: appointmentSliceV2,
    currentGarageData: garageSlice,
    myAccount: myAccountReducer,
};

export let store: any;
let storeType;
const createStore = (preloadedState: {}) => {
    if (typeof window === 'undefined') {
        console.log({ preloadedState });
        return configureStore({
            reducer: { ...reducers },
            preloadedState,
        });
    }

    if (!store) {
        store = configureStore({
            reducer: { ...reducers },
            preloadedState,
        });
    }
    storeType = typeof store;
    return store;
};

export default createStore;
export type AppDispatch = typeof store;
